import { useContext } from '@nuxtjs/composition-api';
import { Params } from '@webplatform/nuxt-cms-js-sdk';

export interface PromotionProduct {
  sku: string;
  name: string;
  price: number | null;
  currency: string;
  slug: string;
  images: string[];
}

const ENDPOINT = '/api/promotions';

// Need to be moved to the frontkit later
const useFetchPromotions = () => {
  const { $axios } = useContext();

  const fetchPromotionById = async (promoId: string, params: Params = {}) => {
    const {
      data: { data },
    } = await $axios.get(`${ENDPOINT}/${promoId}`, {
      params,
    });

    return data as PromotionProduct[];
  };

  return {
    fetchPromotionById,
  };
};

export default useFetchPromotions;
